export default {
  // 系统管理
  'menu.system': '系统管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.system.menu': '菜单管理',
  'menu.system.dept': '部门管理',
  'menu.system.file': '文件管理',

  // 监控管理
  'menu.monitor': '监控管理',
  'menu.monitor.login-log': '登录日志',
  'menu.monitor.oper-log': '操作日志',

  // 登录
  'menu.login': '登录',

  // 登录体系管理
  'menu.login-system': '登录体系',
  'menu.login-system.user': '登录用户',
  'menu.login-system.login-log': '登录日志',
  'menu.login-system.sms-config': '短信配置',

  // 盲盒管理
  'menu.blindbox': '盲盒管理',
  'menu.blindbox.dashboard': '数据看板',
  'menu.blindbox.product': '商品管理',
  'menu.blindbox.category': '分类管理',
  'menu.blindbox.banner': '轮播图管理',
  'menu.blindbox.priceRange': '价格区间',
  'menu.blindbox.welfare': '福利中心',
  'menu.blindbox.order': '订单管理',
  'menu.blindbox.user': '用户管理',
  'menu.blindbox.address': '地址管理',
  'menu.blindbox.invite': '邀请佣金',
  'menu.blindbox.activity': '活动管理',
  'menu.blindbox.asset': '资产管理',
  'menu.blindbox.coupon': '优惠券管理',
  'menu.blindbox.sign': '签到管理',
  'menu.blindbox.gift-code': '礼包码管理',
  'menu.blindbox.daily-limit': '今日限定',
  'menu.blindbox.customer-service': '客服配置',
  'menu.blindbox.theme': '主题配置',
};
